import axiosInstance from './axiosInstance';
import { UploadBusinessType, UploadFileType } from '../types';

/**
 * POST multiple image files in one multipart request (field name `files` per file).
 */
export async function postImageFilesBatch(
  files: File[],
  businessType: UploadBusinessType
): Promise<unknown> {
  const formData = new FormData();
  files.forEach((f) => {
    formData.append('files', f, f.name);
  });
  formData.append('businessType', businessType);
  formData.append('fileType', UploadFileType.IMAGE);
  const { data } = await axiosInstance.post<unknown>('/file', formData);
  return data;
}

export function normalizeBatchUploadItems(responseBody: unknown): unknown[] {
  if (
    responseBody &&
    typeof responseBody === 'object' &&
    'data' in responseBody
  ) {
    const raw = (responseBody as { data: unknown }).data;
    if (Array.isArray(raw)) return raw;
    if (raw != null) return [raw];
  }
  return [];
}
